// --------------------------------------------------------------
// Created On: 2024-11-21
// Author: Zachary Thomas
//
// Last Modified: 2024-11-21
// Modified By: Zachary Thomas
//
// Copyright 2024 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

// Converts a dash-time-string (ex: yyyy-mm-dd) to a slash-time-string (ex: mm/dd/yyyy).
// If we are unable to convert the input string to the new format, then return the input string as the output.
export default function formatDashTimeString(dateString: string): string {
  let newDateString = dateString;
  const dividedDate = dateString.split("-");
  if (dividedDate.length === 3) {
    const years = dividedDate[0];
    let months = dividedDate[1];
    let days = dividedDate[2];
    if (months.length === 1) {
      months = `0${months}`;
    }
    if (days.length === 1) {
      days = `0${days}`;
    }
    if (years.length === 4 && months.length === 2 && days.length === 2) {
      newDateString = `${months}/${days}/${years}`;
    }
  }
  return newDateString;
}
